/*
 * Copyright (c) 2025 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { AttachmentVO, BaseAttachmentDTO } from '@well/attachment/domain';

export class ProofOfHandoverAttachmentDtoModel extends BaseAttachmentDTO {

  proofOfHandoverUuid: string | null = null;

  static override fromAttachmentVo(attachment: AttachmentVO): ProofOfHandoverAttachmentDtoModel {
    const proofOfHandoverAttachmentDto = super.fromAttachmentVo(attachment);
    return { ...proofOfHandoverAttachmentDto, proofOfHandoverUuid: null };
  }
}
